import styled from "styled-components";
import Description from "@mui/icons-material/Description";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
export const DescriptionIcon = styled(Description) `
    color: ${colors.accents_sunset};
    width: 24px;
    height: 24px;
`;
export const HealthRecordExamplesList = styled.ul `
    margin-top: 0;
    padding-left: 24px;

    & li {
        padding-left: 4px;
    }
`;
export const ScopeSectionIcon = styled.img `
    width: 24px;
    height: 24px;
`;
export const ScopeSectionTitle = styled.div `
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const Text = styled.div ``;
export const ScopeList = styled.ul `
    margin-top: 0;
    padding-left: 24px;

    & li {
        padding-left: 4px;
        margin-bottom: 12px;
    }

    & li:last-child {
        margin-bottom: 0;
    }
`;
export const ScopeListItem = styled.li ``;
export const ScopeName = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const ScopeDescription = styled.div ``;
